// Language options - Single source of truth
export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English', icon: '🇬🇧' },
  { value: 'es', label: 'Spanish', icon: '🇪🇸' },
  { value: 'zh-Hans', label: 'Simplified Chinese', icon: '🇨🇳' },
  { value: 'fr', label: 'French', icon: '🇫🇷' },
  { value: 'ja', label: 'Japanese', icon: '🇯🇵' },
  { value: 'ko', label: 'Korean', icon: '🇰🇷' },
  { value: 'ru', label: 'Russian', icon: '🇷🇺' },
  { value: 'de', label: 'German', icon: '🇩🇪' },
  { value: 'zh-Hant', label: 'Traditional Chinese', icon: '🇲🇴' },
  { value: 'yue', label: 'Cantonese Chinese', icon: '🇭🇰' },
  { value: 'fi', label: 'Finnish', icon: '🇫🇮' },
  { value: 'et', label: 'Estonian', icon: '🇪🇪' },
  { value: 'uk', label: 'Ukrainian', icon: '🇺🇦' },
];

// Level options with descriptions (CEFR / CET / JLPT / HSK) - Single source of truth
export const LEVEL_OPTIONS = [
  { value: 'beginner', label: 'Beginner', icon: '🌱', description: 'A1-B1 · HSK 1-3 / JLPT N5-N4' },
  { value: 'intermediate', label: 'Intermediate', icon: '🌿', description: 'B1-B2 · CET-4 / HSK 4 / JLPT N3' },
  { value: 'advanced', label: 'Advanced', icon: '🌳', description: 'B2-C1 · CET-6 / HSK 5 / JLPT N2' },
  { value: 'proficient', label: 'Proficient', icon: '🎯', description: 'C1-C2 · TOEFL / IELTS / HSK 6 / JLPT N1' },
  { value: 'professional', label: 'Professional', icon: '📚', description: 'GRE / Business or PhD level' },
  { value: 'native', label: 'Native', icon: '⭐', description: 'Native speaker' },
];

